import React from 'react'
import { Action } from './style'

export default ({ value, onClick = () => {} }) => (
    <Action onClick={() => onClick()}>
        {value}
    </Action>
)
